import React from 'react'

type Props = {
  className: string
  color: string
  iconColor: string
  title: string
  description: string
  percentage: string
  icon: string
}

const StatisticsCount: React.FC<Props> = ({
  className,
  color,
  iconColor,
  title,
  description,
  percentage,
  icon,
}) => {
  const percentageValue = parseFloat(percentage.replace(/[^0-9.]/g, ''))

  return (
    <div className={`card bg-${color} ${className}`} style={{borderRadius: '12px'}}>
      <div className='card-body d-flex align-items-center' style={{padding: '24px'}}>
        <div className='me-4'>
          <i className={`bi ${icon} text-${iconColor}`} style={{fontSize: '3rem'}}></i>
        </div>
        
        <div className='flex-grow-1'>
          <div className={`text-${iconColor} fw-semibold fs-6 mb-2`}>
            {description}
          </div>
          
          <div className={`text-${iconColor} fw-bolder fs-2x mb-3`} style={{fontSize: '2rem'}}>
            {title}
          </div>
          
          <div className='w-100 mb-2' style={{height: '6px', backgroundColor: 'rgba(255,255,255,0.3)', borderRadius: '3px', overflow: 'hidden'}}>
            <div 
              className={`bg-${iconColor}`} 
              style={{
                height: '100%', 
                width: `${percentageValue}%`,
                borderRadius: '3px',
                transition: 'width 0.3s ease'
              }}
            ></div>
          </div>
          
          <div className={`text-${iconColor} fs-7 fw-semibold`}>
            {percentage}
          </div>
        </div>
      </div>
    </div>
  )
}

export {StatisticsCount}